export enum CurrencyFormats {
  SYMBOL_BEFORE = 'SYMBOL_BEFORE',
  SYMBOL_AFTER = 'SYMBOL_AFTER',
  ISO_CODE_AFTER = 'ISO_CODE_AFTER',
  ISO_CODE_BEFORE = 'ISO_CODE_BEFORE',
  SYMBOL_BEFORE_ISO_CODE_AFTER = 'SYMBOL_BEFORE_ISO_CODE_AFTER',
  ISO_CODE_BEFORE_SYMBOL_BEFORE = 'ISO_CODE_BEFORE_SYMBOL_BEFORE',
  SYMBOL_AFTER_ISO_CODE_AFTER = 'SYMBOL_AFTER_ISO_CODE_AFTER',
  ISO_CODE_BEFORE_SYMBOL_AFTER = 'ISO_CODE_BEFORE_SYMBOL_AFTER',
}
